/**
 * Arkius Certification Kickstarter API
 * Arkius PBC API v5.2026.1012.0845
 *
 * The version of the OpenAPI document: v1
 * Contact: info@arkius.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntityCreationImage } from './entityCreationImage';
import { Commitmentv5 } from './commitmentv5';
import { Founder } from './founder';
import { PropositionTagv5 } from './propositionTagv5';
import { CoFounder } from './coFounder';


export interface PropositionCreationv5 { 
    Title: string;
    Description?: string | null;
    Teaser?: string | null;
    WhatWeAsk?: string | null;
    RequirementsTimeline?: string | null;
    Type: string;
    Images?: Array<EntityCreationImage> | null;
    Tags?: Array<PropositionTagv5> | null;
    MarketSectors?: Array<number> | null;
    Commitments?: Array<Commitmentv5> | null;
    CommitmentsText?: string | null;
    IsDraft?: boolean;
    CallToAction?: string | null;
    Sponsors?: string | null;
    References?: string | null;
    SecondaryPlayers?: string | null;
    Imagine?: string | null;
    Video?: string | null;
    CoFounders?: Array<CoFounder> | null;
    Founders?: Array<Founder> | null;
    OwnershipHasMultipleFounders?: boolean;
    AiGenerated?: boolean;
    ConvertedFromEntityType?: string | null;
    ConvertedFromEntityId?: number | null;
}

